// extracted by mini-css-extract-plugin
module.exports = {"module":"bomb-plate_module__uJb4y","light":"bomb-plate_light__24mja","disarmed":"bomb-plate_disarmed__3QoRi"};